<template>
  <div class="space-y-8">
    <div class="grid gap-3">
      <button
        v-for="opt in options"
        :key="opt.value"
        @click="select(opt.value)"
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === opt.value 
            ? 'btn-primary shadow-lg' 
            : 'btn-outline hover:bg-base-200'
        ]">
        {{ $t(opt.label) }}
      </button>
    </div>
    
    <button 
      class="btn btn-primary btn-lg w-full rounded-xl font-medium disabled:opacity-50" 
      :disabled="!selected" 
      @click="$emit('next')">
      {{ $t("smartLeadForm.next") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

// Safe-cast to string
const selected = ref(typeof props.modelValue.budget === "string" ? props.modelValue.budget : "");

const options = [
  { value: "starter", label: "smartLeadForm.investment.options.starter" },
  { value: "professional", label: "smartLeadForm.investment.options.professional" },
  { value: "premium", label: "smartLeadForm.investment.options.premium" },
];

watch(selected, val => emit("update:modelValue", { ...props.modelValue, budget: val }));
function select(val: string) {
  selected.value = val;
}
</script>
